import React, { LegacyRef } from 'react';
import { Link } from 'gatsby';
import Navigation from './Navigation';
import { Drawer, DrawerContent } from './primitives/drawer';
import PreparedLogo from '../images/logos/Prepared-Logo.svg';

interface SidebarProps {
    open: boolean;
    setOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

const Sidebar = ({ open, setOpen }: SidebarProps): JSX.Element => {
    const headerButtonRef = React.useRef<HTMLButtonElement>(null);
    const closeButtonRef = React.useRef<HTMLButtonElement>(null);
    const navRef = React.useRef<HTMLDivElement>(null);

    React.useEffect(() => {
        if (open) {
            navRef.current?.focus();
        } else {
            headerButtonRef.current?.focus();
        }
    }, [open]);

    return (
        <>
            {!open && (
                <div className="hidden lg:flex items-center justify-between container h-32">
                    <Link to="/" aria-label="Prepared">
                        <PreparedLogo className="h-8" />
                    </Link>
                    <Navigation />
                </div>
            )}

            <header
                className={`z-10 overflow-hidden top-0 sticky lg:hidden ${open ? 'bg-white' : ''}`}
                style={{
                    transform: 'translateY(0)',
                    opacity: '1',
                    display: open ? 'none' : undefined
                }}
                css={{ pointerEvents: 'all' }}
            >
                <div className="container flex items-center justify-between py-4 lg:py-6">
                    <Link to="/" className="no-underline" aria-label="Prepared">
                        <PreparedLogo className="h-7" />
                    </Link>
                    <button
                        id="sidebar-toggle"
                        ref={headerButtonRef}
                        type="button"
                        className="text-xl text-white focus:outline-none focus-visible:outline-auto"
                        aria-expanded={open}
                        aria-controls="sidebar-navigation"
                        onClick={() => setOpen(!open)}
                    >
                        Menü
                    </button>
                </div>
            </header>

            {open && (
                <Drawer open={open} onOpenChange={(e) => setOpen(!e)}>
                    <DrawerContent
                        id="sidebar-navigation"
                        ref={navRef as LegacyRef<HTMLDivElement>}
                        tabIndex={-1}
                        role="dialog"
                        aria-modal="true"
                        placement="right"
                        size="full"
                        animation="fade"
                        className="bg-white"
                    >
                        <div className="container flex items-center justify-between py-4">
                            <Link to="/" aria-label="Prepared">
                                <PreparedLogo className="h-7" />
                            </Link>
                            <button
                                ref={closeButtonRef}
                                type="button"
                                className="text-xl focus:outline-none focus-visible:outline-auto"
                                aria-expanded={open}
                                aria-controls="sidebar-navigation"
                                onClick={() => setOpen(false)}
                            >
                                Menü
                            </button>
                        </div>
                        <Navigation mobile onCloseMenu={() => setOpen(false)} />
                    </DrawerContent>
                </Drawer>
            )}
        </>
    );
};

export default Sidebar;
